module.exports = __webpack_public_path__ + "static/media/44.66e7012b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/44.png
// module id = 616
// module chunks = 0